import { useState } from "react";
import { Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { SECTIONS } from "@/config/sections";
import { HOME } from "@/constants/testIds";
import { SectionLink } from "@/components/SectionLink";

export const MobileMenu = () => {
  const [open, setOpen] = useState(false);
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger
        data-testid={HOME.mobileMenuButton}
        aria-label="Open menu"
        className="md:hidden w-10 h-10 grid place-items-center rounded-full hover:bg-[#F0EBE1] transition-colors"
      >
        <Menu size={22} />
      </SheetTrigger>
      <SheetContent side="right" data-testid={HOME.mobileMenu} className="bg-[#FDFBF7] pt-16">
        <SheetTitle className="font-heading text-sm uppercase tracking-[0.2em] text-[#4E7B68]">Sections</SheetTitle>
        <div className="mt-6 flex flex-col gap-2">
          {SECTIONS.map((s) => (
            <SectionLink
              key={s.id}
              url={s.url}
              nav
              onClick={() => setOpen(false)}
              data-testid={HOME.mobileMenuLink(s.id)}
              className="font-heading text-2xl font-bold px-4 py-3 rounded-2xl hover:bg-[#F0EBE1] transition-colors"
            >
              {s.title}
            </SectionLink>
          ))}
        </div>
        <div className="mt-6 pt-6 border-t border-[#F0EBE1] flex flex-col gap-1">
          {[["favorites", "/favorites", "Favorites"], ["track", "/track", "Track an order"], ["account", "/account", "My account"]].map(([id, url, label]) => (
            <SectionLink key={id} url={url} nav onClick={() => setOpen(false)} data-testid={HOME.mobileMenuLink(id)} className="px-4 py-2.5 rounded-2xl text-stone-700 hover:bg-[#F0EBE1] transition-colors">
              {label}
            </SectionLink>
          ))}
        </div>
      </SheetContent>
    </Sheet>
  );
};
